export default {
  path: '/lvy-face-agreement',
  component: () => import('./LVYFaceAgreement'),
  meta: {
    title: '实人认证服务协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}